'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const find = require('lodash/find');
const map = require('lodash/map');
import { Button as RbButton, Modal, Form } from 'react-bootstrap';
import { Button as RamButton, Wrapper, Button, Menu, MenuItem } from 'react-aria-menubutton';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const StringUtil = require('../../../../app/shared/StringUtil');
import ErrorBox from '../common/ErrorBox';
const ValidateUtil = require('../../util/ValidateUtil');
const SubscriptionPlanStore = require('../../stores/SubscriptionPlanStore');
const SubscriptionPlanActions = require('../../actions/SubscriptionPlanActions');

const intervalOptions = [
    {
        value: Globals.ecommerce.plan_intervals.month,
        content: 'month'
    },
    {
        value: Globals.ecommerce.plan_intervals.year,
        content: 'year'
    }
];

const propTypes = {
    closeHandler: PropTypes.func.isRequired,
    show: PropTypes.bool,
};

const defaultProps = {
    show: false,
};

class NewSubscriptionPlanModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subscriptionPlanStoreState: SubscriptionPlanStore.getState(),
            actionID: null,
            account_type: Globals.users.account_types.INDIVIDUAL,
            token: '',
            display_name: '',
            cost: '10.00',
            interval: Globals.ecommerce.plan_intervals.month,
            pay_method: Globals.ecommerce.process_types.CC,
            ...ValidateUtil.getDefaultValidationState(),
        };

        this.submitHandler = this.submitHandler.bind(this);
        this.onTokenChange = this.onTokenChange.bind(this);
        this.onAccountTypeChange = this.onAccountTypeChange.bind(this);
        this.onDisplayNameChange = this.onDisplayNameChange.bind(this);
        this.onIntervalChange = this.onIntervalChange.bind(this);
        this.onPayMethodChange = this.onPayMethodChange.bind(this);
        this.onCostChange = this.onCostChange.bind(this);
        this.getTokenValidationState = this.getTokenValidationState.bind(this);
        this.getDisplayNameValidationState = this.getDisplayNameValidationState.bind(this);
        this.getCostValidationState = this.getCostValidationState.bind(this);
        this.getPayMethodName = this.getPayMethodName.bind(this);
        this.hasCost = this.hasCost.bind(this);
        this.unsubscribes = [
            SubscriptionPlanStore.listen(this.onSubscriptionPlanChange.bind(this))
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onSubscriptionPlanChange(state) {
        if (
            state.action.id === this.state.actionID
            && !state.action.error
        ) {
            this.props.closeHandler();
            return;
        }

        const additionalState = ValidateUtil.getUpdatedState(this.state.actionID, state);
        this.setState({ subscriptionPlanStoreState: state, ...additionalState });
    }

    submitHandler(projectName) {
        const hasCost = this.hasCost();
        let cost = 0;
        let interval = this.state.interval;
        if (hasCost) {
            // convert from dollars to cents (no decimal)
            cost = Math.floor(this.state.cost * 100 + 0.5);
        }
        else {
            interval = 'none'; // TBD
        }

        // make sure token is unique and not blank
        if (!this.getTokenValidationState()) {
            this.setState({
                error: {
                    message: 'invalid token ( must be unique and not blank )'
                }
            });
            return;
        }

        const actionID = uuid.v4();
        this.setState({ actionID: actionID }, () => {
            SubscriptionPlanActions.createPlan(actionID, {
                account_type: this.state.account_type,
                display_name: this.state.display_name.trim(),
                token: this.state.token.trim(), // alphanumeric id for a plan, which we specify (i.e. 'individual-monthly')
                cost: cost,
                interval: interval,
                pay_method: this.state.pay_method, // CC, PO, or FREE
            });
        });
    }

    onTokenChange(e) {
        this.setState({ token: e.target.value });
    }

    onAccountTypeChange(value) {
        this.setState({ account_type: value });
    }

    onDisplayNameChange(e) {
        this.setState({ display_name: e.target.value });
    }

    onIntervalChange(value) {
        this.setState({ interval: value });
    }

    onPayMethodChange(value) {
        this.setState({ pay_method: value });
    }

    onCostChange(e) {
        this.setState({ cost: e.target.value });
    }

    getTokenValidationState() {
        const token = this.state.token.trim();
        if (!token) {
            return  false;
        }

        const existingPlan = find(this.state.subscriptionPlanStoreState.plans, { token: token });
        if (existingPlan) {
            return false;
        }

        return true;
    }

    getDisplayNameValidationState() {
        const n = this.state.display_name.trim();
        if (!n) {
            return false;
        }

        return true;
    }

    getCostValidationState() {
        const numStr = this.state.cost;
        const regex = /^[0-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
        if (!regex.test(numStr)) {
            return false;
        }

        return true;
    }

    getPayMethodName(payType) {
        switch (payType) {
            case Globals.ecommerce.process_types.CC: {
                return 'Credit Card';
            }
            case Globals.ecommerce.process_types.PO: {
                return 'Purchase Order';
            }
            case Globals.ecommerce.process_types.FREE: {
                return 'Free';
            }
            default: {
                return 'Invalid';
            }
        }        
    }

    hasCost() {
        return ([Globals.users.account_types.FREE, Globals.users.account_types.FREE_V2].indexOf(this.state.account_type) === -1)
            && (this.state.pay_method === Globals.ecommerce.process_types.CC);
    }

    render() {
        const self = this;
        const hasCost = this.hasCost();
        let aTypeDisplayName;
        const accountTypeMenuItems = map(Globals.users.account_types_available, (aType) => {
            let itemClass = 'AriaMenuButton-menuItem';
            let displayName = StringUtil.getStingForAccountTypeAdmin(aType);
            if (self.state.account_type === aType) {
                itemClass += ' is-selected';
                aTypeDisplayName = displayName;
            }

            return (
                <li className='AriaMenuButton-menuItemWrapper' key={aType}>
                    <MenuItem
                        className={itemClass}
                        value={aType}
                        text={displayName}
                    >
                        {displayName}
                    </MenuItem>
                </li>
            );
        });

        let intervalChooser;
        if (hasCost) {
            let currentIntervalName;
            const intervalMenuItems = intervalOptions.map((interval) => {
                let itemClass = 'AriaMenuButton-menuItem';
                if (this.state.interval === interval.value) {
                    itemClass += ' is-selected';
                    currentIntervalName = interval.content;
                }

                return (
                    <li className='AriaMenuButton-menuItemWrapper' key={interval.value}>
                        <MenuItem
                            className={itemClass}
                            value={interval.value}
                            text={interval.content}
                        >
                            {interval.content}
                        </MenuItem>
                    </li>
                );
            });

            intervalChooser = (
                <div>
                    <label htmlFor="plan-interval">interval</label>
                    <Wrapper
                        id="plan-interval"
                        className='AriaMenuButton margin-left-sm'
                        onSelection={this.onIntervalChange}
                    >
                        <RamButton className='AriaMenuButton-trigger'>
                            {currentIntervalName}
                        </RamButton>
                        <Menu>
                            <ul className='AriaMenuButton-menu'>
                                {intervalMenuItems}
                            </ul>
                        </Menu>
                    </Wrapper>
                </div>
            );
        }

        let currentPayMethod;
        const payMethodMenuItems = map(Globals.ecommerce.process_types, (payType) => {
            let itemClass = 'AriaMenuButton-menuItem';
            const payName = self.getPayMethodName(payType);
            if (self.state.pay_method === payType) {
                itemClass += ' is-selected';
                currentPayMethod = payName;
            }

            return (
                <li className='AriaMenuButton-menuItemWrapper' key={payType}>
                    <MenuItem
                        className={itemClass}
                        value={payType}
                        text={payName}
                    >
                        {payName}
                    </MenuItem>
                </li>
            );
        });

        const payMethodChooser = (
            <div>
                <label htmlFor="plan-interval">pay method</label>
                <Wrapper
                    id="plan-interval"
                    className='AriaMenuButton margin-left-sm'
                    onSelection={this.onPayMethodChange}
                >
                    <RamButton className='AriaMenuButton-trigger'>
                        {currentPayMethod}
                    </RamButton>
                    <Menu>
                        <ul className='AriaMenuButton-menu'>
                            {payMethodMenuItems}
                        </ul>
                    </Menu>
                </Wrapper>
            </div>
        );

        return (
            <Modal
                className='single-input-modal'
                show={this.props.show}
                enforceFocus={false}
                backdrop={false}
                animation={false}
                keyboard
                onHide={this.props.closeHandler}
            >
                <Modal.Header closeButton onHide={this.props.closeHandler}>
                    <Modal.Title>new subscription plan</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorBox error={this.state.error} />
                    <Form>
                        <label htmlFor="plan-acc-type">account type</label>
                        <Wrapper
                            id="plan-acc-type"
                            className='AriaMenuButton margin-left-sm'
                            onSelection={this.onAccountTypeChange}
                        >
                            <RamButton className='AriaMenuButton-trigger'>
                                {aTypeDisplayName}
                            </RamButton>
                            <Menu>
                                <ul className='AriaMenuButton-menu'>
                                    {accountTypeMenuItems}
                                </ul>
                            </Menu>
                        </Wrapper>

                        <Form.Group controlId="admin-sub-token">
                            <Form.Label>token</Form.Label>
                            <Form.Control
                                aria-label={this.props.ariaLabel}
                                value={this.state.token}
                                onChange={this.onTokenChange}
                                isValid={this.getTokenValidationState()}
                            />
                        </Form.Group>

                        <Form.Group controlId="admin-sub-disp_name">
                            <Form.Label>display name</Form.Label>
                            <Form.Control
                                aria-label={this.props.ariaLabel}
                                value={this.state.display_name}
                                onChange={this.onDisplayNameChange}
                                isValid={this.getDisplayNameValidationState()}
                            />
                        </Form.Group>

                        {payMethodChooser}

                        {intervalChooser}

                        {(hasCost) &&
                            <Form.Group controlId="admin-sub-cost">
                                <Form.Label>cost</Form.Label>
                                <Form.Control
                                    aria-label={this.props.ariaLabel}
                                    value={this.state.cost}
                                    onChange={this.onCostChange}
                                    isValid={this.getCostValidationState()}
                                />
                            </Form.Group>
                        }
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <RbButton
                        disabled={!!this.state.actionID}
                        onClick={this.submitHandler}
                    >
                        add
                    </RbButton>
                </Modal.Footer>
            </Modal>
        );
    }
}

NewSubscriptionPlanModal.propTypes = propTypes;
NewSubscriptionPlanModal.defaultProps = defaultProps;

export default NewSubscriptionPlanModal;